export default class Time {
    constructor(hours, minutes) {
        this.hours = hours;
        this.minutes = minutes;
    }

    durationTo(time) {
        let minutesFrom = this.hours * 60 + this.minutes;
        let minutesTo = time.hours * 60 + time.minutes;

        if (minutesTo < minutesFrom) {
            minutesTo += 24 * 60;
        }

        let minutes = minutesTo - minutesFrom;

        let hours = Math.floor(minutes / 60);
        minutes = minutes % 60;

        if (minutes < 10) {
            minutes = '0' + minutes;
        }

        return hours + ':' + minutes;
    }

    durationInMinutes(other) {
        return (other.hours - this.hours) * 60 + other.minutes - this.minutes;
    }

    toString() {
        let hours = this.hours;
        let minutes = this.minutes;
        if (hours < 10) {
            hours = '0' + hours;
        }
        if (minutes < 10) {
            minutes = '0' + minutes;
        }

        return hours + ':' + minutes;
    }

    isAfter(time) {
        return this.hours * 60 + this.minutes > time.hours * 60 + time.minutes;
    }

    static fromString(string) {
        if (!/^([01][0-9]|2[0-3]):[0-5][0-9]$/.test(string)) {
            throw new Error(string + ' is not a valid time format');
        }

        let elements = string.split(':');
        let hours = parseInt(elements[0]);
        let minutes = parseInt(elements[1]);

        return new Time(hours, minutes);
    }
}
